import { ActionIcon } from "@mantine/core";
import React from "react";
import { Trash, X } from "tabler-icons-react";

import { Issue, User } from "types";

import DeleteModal from "./DeleteModal";
import styles from "./ModalTitle.module.css";
import { useGetUser } from "api/users/getUser";

type ModalTitleProps = {
  onCloseIssueModal: () => void;
  openDeleteModal: boolean;
  onOpenDeleteModal: () => void;
  onCloseDeleteModal: () => void;
  issue: Issue;
  orgId: string | undefined;
  members: User<string>[];
};

function ModalTitle({
  onCloseIssueModal,
  openDeleteModal,
  onOpenDeleteModal,
  onCloseDeleteModal,
  issue,
  members,
  orgId,
}: ModalTitleProps) {
  const { data: user } = useGetUser();
  return (
    <>
      <DeleteModal
        onCloseIssueModal={onCloseIssueModal}
        openDeleteModal={openDeleteModal}
        // members={members}
        onCloseDeleteModal={onCloseDeleteModal}
        issue={issue}
        orgId={orgId}
      />
      <div className={styles.container}>
        <h2 className={styles.title}>Issue Details</h2>
        <div className={styles.actions}>
          {user?.role !== "member" && issue.status !== "done" && (
            <ActionIcon
              color="dark"
              className={styles["action-btn"]}
              onClick={onOpenDeleteModal}
              aria-label="Delete issue"
            >
              <Trash size={20} />
            </ActionIcon>
          )}

          <ActionIcon
            color="dark"
            className={styles["action-btn"]}
            onClick={onCloseIssueModal}
            aria-label="Close issue details modal"
          >
            <X size={20} />
          </ActionIcon>
        </div>
      </div>
    </>
  );
}

export default ModalTitle;
